<div
  *ngIf="!loading"
  class="px-3 pt-8">
  <p class="font-medium text-2xl">Для начала работы с сервисом выберите откуда будет производиться экспорт данных</p>

  <div class="flex flex-wrap justify-content-center align-items-center gap-5 mt-4">
    <crm-button
      label="Выписка из Банка"
      styleClass="p-button-lg welcome-system-selection-button"
      (onClick)="stepChange.emit(WelcomeSystemStepEnum.IMPORT_SELECTION_BANK)"></crm-button>

    <crm-button
      label="1С Предприяте 8.3"
      styleClass="p-button-lg welcome-system-selection-button"
      (onClick)="stepChange.emit(WelcomeSystemStepEnum.IMPORT_FROM_1C)"></crm-button>

    <crm-button
      label="Демо-аккаунт"
      styleClass="p-button-lg welcome-system-selection-button"
      (onClick)="clickDemoAccount()"></crm-button>
  </div>

  <div class="flex justify-content-center mt-8">
    <p
      class="text-sm text-gray-500 hover:frm-color-blue-light cursor-pointer"
      (click)="reminderWelcome()">
      Напомнить позже
    </p>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-3 pt-3"></crm-spinner>
